// Card.tsx - one monochrome text-presentation card pip, the React port of the mockup's cardHTML().
// Rank glyph top-left with a small suit under it, and a large center pip. Red for diamonds/hearts.
// Sizing (felt board vs hero pod) is inherited from the parent .board / .hero context in felt.css.
import type { CardIndex } from '@postflop/schema';
import { decodeCard } from '../engine/cards';

export interface CardProps {
  card: CardIndex;
  /** play the deal-in animation (new card this street). */
  deal?: boolean;
}

export function Card({ card, deal }: CardProps) {
  const { rank, glyph, red } = decodeCard(card);
  const cls = 'pcard' + (red ? ' r' : '') + (deal ? ' deal' : '');
  return (
    <div className={cls}>
      <span className="idx">
        {rank}
        <s>{glyph}</s>
      </span>
      {/* second corner index, bottom-right; CSS shows it on large (hero) cards only */}
      <span className="idx br">
        {rank}
        <s>{glyph}</s>
      </span>
      <span className="pip">{glyph}</span>
    </div>
  );
}
